import styled from "styled-components";
import { Dialog, Popper } from "@mui/material";

import { StyledFilters, StyledTab } from "@/components/molecules/FilterOptions/styled";
import { breakpoints } from "@/styles/breakpoints";

export const StyledQuickSearchButtonContainer = styled.form`
    width: fit-content;
    padding: 0 4px;
    margin: 0 10px;
    font-size: var(--size-14);
    background: var(--color-white);
    border-radius: var(--radius-10);
    text-transform: uppercase;
    display: flex;
    align-items: center;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);

    @media ${breakpoints.xs} {
        padding: 0;
    }

    button {
        padding: 0;
        min-width: 44px !important;
    }

    button,
    .input-container,
    .input-container .input {
        height: 32px;
        border-radius: var(--radius-10);
    }

    .input-container {
        padding: 0 12px;
    }

    .input {
        @media ${breakpoints.smMin} {
            transition: width 0.2s ease-in-out;
            width: 12ch;

            &:focus {
                width: 16ch;
            }
        }
    }

    svg {
        padding-right: 4px;
        padding-left: 4px;
        width: 18px;
        height: 18px;

        path {
            fill: var(--color-primary);
        }
    }

    .MuiInputAdornment-root {
        margin: 0;
    }

    .MuiInputBase-adornedEnd p {
        font-size: var(--size-10);
        color: var(--color-grey-900);
        font-weight: bold;
        line-height: 20px;
        margin-left: 4px;
        border: 1px solid var(--color-grey-700);
        padding: 0px 6.4px;
        border-radius: var(--radius-5);
    }

    @media ${breakpoints.xs} {
        font-size: var(--size-12);
    }
`;

export const StyedDialog = styled(Dialog)`
    header,
    footer {
        background-color: var(--color-secondary-light);
    }

    header {
        svg {
            width: 20px;
            height: 20px;
        }

        div.search-field-container {
            padding: 8px;
            display: grid;
            grid-gap: 8px;
            grid-template-columns: auto 44px 44px;

            button {
                min-width: 44px !important;
                padding-left: unset;
                padding-right: unset;

                svg {
                    path {
                        fill: var(--color-white);
                    }
                }
            }

            button:first-of-type {
                svg {
                    path {
                        fill: var(--color-primary);
                    }
                }
            }

            button,
            input {
                height: 32px;
                border-radius: var(--radius-10);
            }

            .input {
                background: var(--color-white);
                padding: 0 12px;
            }
        }

        hr {
            border: 0;
            border-top: 1px solid var(--color-white);
        }

        div.select-root {
            background: unset;
            padding-left: 16px;
            padding-right: 16px;

            fieldset {
                border: 0;
            }

            .select {
                text-align: center;
                font-size: var(--size-16);
                color: var(--color-secondary);
            }

            .select-icon {
                margin-right: 14px;

                path {
                    fill: #696969;
                }
            }
        }
    }

    footer {
        bottom: 0;
        position: absolute;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        font-size: var(--size-14);
        color: var(--color-grey-900);
        line-height: 24px;

        p {
            text-align: center;
            padding: 6px 16px;
        }
    }

    .MuiList-root {
        padding: 0;
    }

    .MuiListItemIcon-root {
        min-width: 36px;
    }

    .MuiListItemText-root {
        margin-top: 0;
        margin-bottom: 0;
    }

    p,
    .MuiListItemText-primary,
    .MuiListItemText-secondary {
        line-height: 24px;
        font-size: var(--size-14);
    }

    p,
    .MuiListItemText-primary {
        color: var(--color-grey-900);
    }

    p {
        display: block;
        margin: 0;
    }

    a {
        padding-top: 0;
        padding-bottom: 0;
    }

    .MuiListItemText-secondary {
        color: var(--color-grey-800);
        font-style: italic;
    }

    li {
        min-height: 56px;
    }

    li[aria-selected="true"] {
        background-color: rgba(0, 0, 0, 0.04) !important;
    }
`;

export const StyledPopover = styled(Popper)`
    .popover-paper {
        min-width: 600px;
        max-width: 800px;
        padding: 0 0 8px;
        margin-top: 2px;

        ${StyledFilters} {
            margin-left: 8px;
            margin-right: 8px;
        }

        ${StyledTab} {
            @media ${breakpoints.xsMin} {
                min-width: 40px;
            }
        }

        .MuiList-root {
            padding: 0;
        }

        .MuiListItemIcon-root {
            min-width: 36px;
        }

        .MuiListItemText-primary,
        .MuiListItemText-secondary {
            display: inline;
        }

        p,
        .MuiListItemText-primary,
        .MuiListItemText-secondary {
            display: inline;
            line-height: 24px;
            font-size: var(--size-14);
        }

        p,
        .MuiListItemText-primary {
            color: var(--color-grey-900);
        }

        p {
            text-align: center;
            display: block;
            margin: 0;
            padding: 8px 16px;
        }

        .MuiListItemText-secondary {
            color: var(--color-grey-800);
            font-style: italic;
            margin-left: 8px;
        }

        .tab-indicator {
            border-radius: 5px;
        }

        a:hover {
            background-color: inherit;
        }

        li[aria-selected="true"] a {
            background-color: rgba(0, 0, 0, 0.04) !important;
        }
    }

    @media ${breakpoints.xs} {
        transform: unset !important;

        .popover-paper {
            position: fixed;
            top: -10px !important;
            left: 0 !important;

            width: 100%;
            min-width: inherit;
            max-width: inherit;
            height: 100%;
            max-height: inherit;
            padding: 16px;
        }
    }
`;
